import types from "rdx/modules/emailVerification/types";
import createAction from "rdx/utils/createAction";

export default {
  verifyEmailRequest: (payload) => createAction(types.VERIFY_EMAIL_REQUEST, payload),
  resendVerificationEmailRequest: (payload) => createAction(types.RESEND_VERIFICATION_EMAIL_REQUEST, payload),
  setVerifyEmailStatus: (payload) => createAction(types.SET_VERIFY_EMAIL_STATUS, payload),
  setVerifyStripeError: (payload) => createAction(types.SET_VERIFY_STRIPE_ERROR, payload),
  // INSERTION_PT (for script, do not remove)
};
